/**
 * Format bytes into a human-readable string
 *
 * @example
 * ```
 * formatBytes(0); // "0 KB"
 * formatBytes(500); // "500 B"
 * formatBytes(1024); // "1 KB"
 * formatBytes(1024 * 1024); // "1 MB"
 * formatBytes(1024 * 1024 * 1024); // "1 GB"
 * ```
 *
 */
export function formatBytes(bytes: number): string {
  // Handle negative values
  if (bytes <= 0) return '0 KB';

  // Byte
  const kb = bytes / 1024;
  if (kb < 1) return `${bytes.toFixed(0)} B`;

  // Kilobyte
  if (kb < 1024) return `${kb.toFixed(0)} KB`;

  // Megabyte
  const mb = kb / 1024;
  if (mb < 1024) return `${mb.toFixed(2)} MB`;

  // Gigabyte
  const gb = mb / 1024;
  return `${gb.toFixed(2)} GB`;
}
